import type { BreadcrumbItemConfig } from '../components/layout/PageBreadcrumb';

// Static route breadcrumbs
export const routeBreadcrumbs: Record<string, BreadcrumbItemConfig[]> = {
  '/tax-returns': [
    { label: 'Dashboard', href: '/' },
    { label: 'Tax Returns' },
  ],
  '/outreach': [
    { label: 'Dashboard', href: '/' },
    { label: 'Client Outreach' },
  ],
  '/drake': [
    { label: 'Dashboard', href: '/' },
    { label: 'Drake Import' },
  ],
};

// Dynamic breadcrumb builder for tax return detail
export function buildTaxReturnBreadcrumbs(
  clientName: string,
  taxYear: number
): BreadcrumbItemConfig[] {
  return [
    { label: 'Dashboard', href: '/' },
    { label: 'Tax Returns', href: '/tax-returns' },
    { label: `${clientName} - ${taxYear}` },
  ];
}
